import uuid from 'uuid/v4'

function createUUID() {
    return uuid()
}

export default createUUID